import { Icon } from '@yes.technology/react-toolkit'
import { useState } from 'react'
import { useTranslation } from 'react-i18n-lite'
import useStyleMaps from 'site/Renderer/hooks/useStyleMap'
import {
  LeftSliderButton,
  RightSliderButton,
  TextSliderActionsContainer,
  TextSliderContainer
} from './TextSlider.styles'
import { TextSliderProps } from './TextSlider.types'
import TextSliderCard from './TextSliderCard'

const isValidIndex = (index: number, length: number): boolean =>
  isNaN(index) || index < 0 || index > length

const TextSlider = ({
  props: {
    objects,
    color = '#303032',
    right_arrow_color: rightArrowColor,
    left_arrow_color: leftArrowColor,
    initial_slider = 0,
    styleMap = {},
    ...htmlProps
  }
}: TextSliderProps) => {
  const [index, setIndex] = useState<number>(
    isValidIndex(initial_slider, objects.length - 1) ? 0 : initial_slider
  )

  const { t } = useTranslation()

  const style = useStyleMaps(styleMap)

  if (!objects || objects.length === 0) {
    return null
  }

  const currentSlider = objects[index] ?? null

  const onPrevClick = () => {
    if (index > 0) {
      setIndex(index - 1)
    } else {
      setIndex(objects.length - 1)
    }
  }

  const onNextClick = () => {
    if (index < objects.length - 1) {
      setIndex(index + 1)
    } else {
      setIndex(0)
    }
  }

  return (
    <TextSliderContainer style={style} {...htmlProps}>
      {currentSlider && <TextSliderCard {...currentSlider} />}
      <TextSliderActionsContainer>
        <LeftSliderButton
          onClick={onPrevClick}
          $color={color}
          $icColor={leftArrowColor}
          aria-label={t('navigation-slider.previous')}
        >
          <Icon iconName='NavigationLeft' hexColorCode={color} />
        </LeftSliderButton>
        <RightSliderButton
          onClick={onNextClick}
          $color={color}
          $icColor={rightArrowColor}
          aria-label={t('navigation-slider.next')}
        >
          <Icon iconName='NavigationRightFill' hexColorCode={color} />
        </RightSliderButton>
      </TextSliderActionsContainer>
    </TextSliderContainer>
  )
}

export default TextSlider
